import React, { useState, useEffect } from 'react';

import Loadable from '../ui/loading/Loadable.js';
import WeightInput from './WeightInput.js';
// This wraps WeightInput, and just handles the units.  It gets the default displayUnit from the api
// And the base unit is kg

import api from '../../api/index.js';

export default (props) => {
	const [units, setUnits] = useState(false);

	const refresh = async () => {
		const displayunit = await api.settings.get('display_units_mass');
		console.log("Mass display units", displayunit);
		setUnits(displayunit);
	}


	useEffect(()=>{
		if (units === false)
			refresh();
	});


	return (
		<Loadable ready={units !== false}>
			<WeightInput 
				displayUnits={units}
				placeholder={props.placeholder}
				value={props.value}
				baseUnits="kg"
				name={props.name} 
				onChange={props.onChange}
			/>
		</Loadable>
	);
}
